export default __webpack_public_path__ + "static/breadcrumbs-overflow-dark-78fabf8e5fb2803000fd458151baf3faac92da4f401f4bbe94e49039ad6761f6.png";